import React from 'react';

export const HouseWithWarn = () => (
  <g xmlns="http://www.w3.org/2000/svg">
    <g
      id="Group_1191"
      data-name="Group 1191"
      transform="matrix(18.472178,0,0,18.334274,-9546.1657,-1464.2239)"
    >
      <path
        id="House"
        d="M 24.758,1.055 A 0.992,0.992 0 0 0 24.185,1.262 L 1.381,19.055 A 0.992,0.992 0 0 0 2.6,20.62 l 1.373,-1.071 v 26.066 a 0.992,0.992 0 0 0 0.991,0.991 h 13.715 a 0.992,0.992 0 0 0 0.323,0 h 11.575 a 0.992,0.992 0 0 0 0.323,0 h 13.723 a 0.992,0.992 0 0 0 0.991,-0.991 V 19.549 l 1.373,1.071 a 0.99217249,0.99217249 0 1 0 1.22,-1.565 l -7.55,-5.891 c 0,-0.206 0,-0.445 0,-0.755 0,-0.725 0,-1.684 0,-2.639 0,-1.912 0,-3.813 0,-3.813 A 0.992,0.992 0 0 0 39.666,4.966 H 35.7 a 0.992,0.992 0 0 0 -0.991,0.991 c 0,0 0,1.147 0,2.295 0,0.1 0,0.173 0,0.271 L 25.4,1.262 A 0.992,0.992 0 0 0 24.758,1.055 Z m 0.036,2.245 10.29,8.028 a 0.992,0.992 0 0 0 0.98,0.139 l 0.614,-0.792 c 0,0 0.005,-0.053 0.006,-0.064 0.001,-0.011 0,-0.028 0,-0.035 0,-0.007 0,-0.02 0,-0.027 0,-0.007 0,-0.028 0,-0.046 0,-0.037 0,-0.087 0,-0.151 0,-0.127 0,-0.307 0,-0.523 0,-0.431 0,-1 0,-1.578 0,-0.653 0,-0.863 0,-1.305 h 1.983 c 0,0.637 0,1.407 0,2.821 0,0.956 0,1.914 0,2.639 0,0.363 0,0.666 0,0.883 0,0.217 0,0.28 0,0.368 a 0.992,0.992 0 0 0 0.381,0.771 L 43.632,18 v 26.624 h -11.9 V 25.786 H 17.854 V 44.624 H 5.957 V 18 Z m -4.957,24.469 h 9.914 v 16.855 h -9.914 z m 6.94,6.94 a 0.991,0.991 0 1 0 0.991,0.991 0.991,0.991 0 0 0 -0.991,-0.991 z"
        transform="translate(515.993,83.577)"
        fill="#333333"
        opacity="0.2"
      />
      <g
        id="Icon_Alert-medium"
        data-name="Icon/Alert-medium"
        transform="translate(-211.402,-804.701)"
      >
        <g
          id="Polygon_3"
          data-name="Polygon 3"
          transform="translate(764.402,918.701)"
          fill="#fdf4df"
        >
          <path
            d="M 20.467621,18.999996 H 3.5323811 c -0.52616,0 -0.7838402,-0.35477 -0.8702002,-0.507301 -0.08636,-0.152529 -0.2579999,-0.556009 0.01271,-1.0072 L 11.142501,3.3728056 c 0.26292,-0.43819 0.68726,-0.4855001 0.8575,-0.4855001 0.17024,0 0.59457,0.0473 0.85749,0.4854901 l 8.46763,14.1127104 c 0.27071,0.45118 0.09907,0.85466 0.0127,1.007189 -0.08636,0.152531 -0.344028,0.507301 -0.8702,0.507301 z"
            stroke="none"
            id="path443"
          />
          <path
            d="m 12.000001,3.8873062 c -2e-6,0 -4e-6,0 0,-1.14e-5 L 3.5323811,17.999996 H 20.467611 L 12.000003,3.8873062 c -10e-7,0 -10e-7,0 -2e-6,0 M 12,1.8873024 c 0.663291,0 1.326581,0.3236675 1.714981,0.9710026 l 8.467621,14.112699 c 0.799839,1.333052 -0.160391,3.028992 -1.714981,3.028992 H 3.5323811 c -1.5545903,0 -2.5148201,-1.69594 -1.7149907,-3.028992 L 10.285011,2.858305 C 10.673416,2.2109699 11.336708,1.8873024 12,1.8873024 Z"
            stroke="none"
            fill="#eda400"
            id="path445"
          />
        </g>
        <path
          id="Path"
          d="M 0,0 V 5.1 H 1.7 V 0 Z"
          transform="translate(775.552,926.576)"
          fill="#eda400"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M 0,0 V 1.7 H 1.7 V 0 Z"
          transform="translate(775.552,933.377)"
          fill="#eda400"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
        />
      </g>
    </g>
  </g>
);
